import { render, staticRenderFns } from "./EighthSection.vue?vue&type=template&id=dd1da2dc&"
import script from "./EighthSection.vue?vue&type=script&lang=ts&"
export * from "./EighthSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports